export class ApplicationArtatech {
    constructor(
        public id?: number,
        public name?: string,
        public packageName?: string,
        public description?: string,
        public downloadUrl?: string,
        public md5?: string,
        public lastModificationDate?: any,
        public hash?: string,
        public hashType?: string
    ) {
    }


}
export class LocalFile {
    constructor(
        public localFileName?: string,
        public url?: string
    ) {
    }


}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech.model.ts